import React from "react";
import { SelectionSelector } from "./selection-selector";

const selectionOptions = ["I am a new customer.", "I have an account."];

export const SelectionAndCoverage = () => {
	return (
		<div className="w-full max-w-[31rem] md:mx-auto">
			<SelectionSelector
				selectionOptions={selectionOptions}
			/>
		</div>
	);
};
